import { useEffect, useState } from "react";
import { IconClose, IconHamberger } from "../../Assets/Icons";
import { Link } from "react-router-dom";

interface NavbarProps {
  isMenuOpen: boolean;
  setIsMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const NavbarTwo: React.FC<NavbarProps> = ({ isMenuOpen, setIsMenuOpen }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[95%] md:w-[90%]
        rounded-3xl px-4 py-3 flex justify-between items-center
        transition-all duration-300
        ${isScrolled ? "bg-white shadow-md backdrop-blur-md" : "bg-white"}
      `}>
      {/* LOGO */}
      <Link to="/" className="flex items-center gap-2">
        <img src="/images/logo_peduli.png" alt="Logo" className="w-12 h-12 md:w-14 md:h-14" />
      </Link>

      {/* BREADCRUMB DESKTOP */}
      <div className="hidden lg:flex items-center gap-2 text-sm text-gray-600 font-medium">
        <Link to="/" className="hover:text-red-500 transition">
          Beranda
        </Link>
        <span className="text-gray-400">›</span>
        <Link to="/news" className="hover:text-red-500 transition">
          Berita
        </Link>
        <span className="text-gray-400">›</span>
        <span className="text-red-500 font-semibold">Detail Berita</span>
      </div>

      {/* MOBILE TOGGLE */}
      <button className="lg:hidden z-50 text-black" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label={isMenuOpen ? "Close menu" : "Open menu"}>
        {isMenuOpen ? <IconClose /> : <IconHamberger />}
      </button>

      {/* MOBILE MENU (BREADCRUMB) */}
      <div
        className={`fixed top-0 left-0 w-full bg-white z-40 rounded-b-3xl
          transition-transform duration-300 ease-in-out
          ${isMenuOpen ? "translate-y-0 opacity-100" : "-translate-y-full opacity-0"}
        `}>
        <div className="pt-24 pb-10 px-6 flex flex-col items-center gap-4 text-base font-medium text-gray-700">
          <Link to="/" onClick={() => setIsMenuOpen(false)} className="hover:text-red-500">
            Beranda
          </Link>

          <span className="text-gray-400">›</span>

          <Link to="/" onClick={() => setIsMenuOpen(false)} className="hover:text-red-500">
            Berita
          </Link>

          <span className="text-gray-400">›</span>

          <span className="text-red-500 font-semibold">Detail Berita</span>
        </div>
      </div>
    </header>
  );
};

export default NavbarTwo;
